import React, { useState, useEffect, useContext } from "react";
import PageHeader from "../pageheader/PageHeader";
import styles from "./AnsQandAUserAll.module.css";
import * as publicApi from "../../service/publicApi";
import { RedirectCode400 } from "../RedirectCode400";
import { useNavigate } from "react-router-dom";
import { CurrentUserContext } from "../../App";
import Pagination from "../public/pagination/pagination";
import Breadcrumb from "../public/breacrumb/breadcrumb";

function NewAnsQandAUserAll() {
  const navigate = useNavigate();
  const { setIsMessage } = useContext(CurrentUserContext);

  const [openIndex, setOpenIndex] = useState(null);
  const [data, setData] = useState([]);
  const [title, setTitle] = useState("");
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [isLoad, setIsLoad] = useState(false);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    if (title.trim() === "") {
      FaqApi();
    }
  }, [page, title]);

  const handleSearchTitle = () => {
    setPage(1);
    FaqApi();
  };

  const FaqApi = async () => {
    setIsLoad(true);
    try {
      const res = await publicApi.getFAQ(page, 10, title);
      if (res?.data?.code === 200) {
        setData(res.data.faq_list || []);
        setMaxPage(Math.ceil(res.data.amount / 10));
        setTotal(res.data.amount);
      } else if (res?.data?.code === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data:
            res?.data?.message_th ||
            res?.data?.message ||
            "Error fetching data",
        });
      }
    } catch (error) {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    } finally {
      setIsLoad(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= maxPage) {
      setPage(newPage);
    }
  };

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "คำถามที่พบบ่อย", url: "/" },
  ];

  return (
    <>
      <Breadcrumb pathItems={pathItems} />

      <PageHeader titlename="คำถามที่พบบ่อย" />
      <div className="my-4 relative flex lg:!w-auto w-[600px]">
        <label htmlFor="search" className="sr-only">
          ค้นหา
        </label>
        <input
          id="search"
          type="text"
          placeholder="ค้นหา"
          maxLength="17"
          className={styles.input}
          autoComplete="off"
          onChange={(e) => setTitle(e.target.value)}
          value={title}
        />
        <button
          onClick={handleSearchTitle}
          className="absolute top-0 right-[1rem] h-full flex justify-end items-center gap-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icons-tabler-outline icon-tabler-search"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
            <path d="M21 21l-6 -6" />
          </svg>
          <span>ค้นหา</span>
        </button>
      </div>

      <div>
        <div id="accordion-collapse" className="bg-[#fff]">
          {isLoad ? (
            <p>กำลังโหลดข้อมูล...</p>
          ) : data.length > 0 ? (
            data.map((content, index) => {
              if (!content.title || content.title.trim() === "") return null;

              return (
                <div key={index} className="last:border-b">
                  <h2>
                    <button
                      id={`accordion-collapse-heading-${index}`}
                      type="button"
                      className="flex items-center justify-between w-full p-5 font-medium rtl:text-right border border-b-0 border-gray-200 hover:bg-gray-100 gap-3"
                      onClick={() => toggleAccordion(index)}
                      aria-expanded={openIndex === index}
                      aria-controls={`accordion-collapse-body-${index}`}
                    >
                      <span>{content.title}</span>

                      <svg
                        data-accordion-icon
                        className={`w-3 h-3 rotate-180 shrink-0 ${
                          openIndex === index ? "!rotate-0 text-[#43A1EF]" : ""
                        }`}
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 10 6"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M9 5 5 1 1 5"
                        />
                      </svg>
                    </button>
                  </h2>
                  <div
                    id={`accordion-collapse-body-${index}`}
                    className={openIndex === index ? "" : "hidden"}
                    aria-labelledby={`accordion-collapse-heading-${index}`}
                  >
                    <div className="p-5 border border-[#43A1EF] bg-[#F6FBFF]">
                      <p
                        className="mb-2 dark:text-gray-400 overflow-auto break-words"
                        dangerouslySetInnerHTML={{ __html: content.detail }}
                      ></p>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <p className="text-gray-500">ไม่พบข้อมูล</p>
          )}

          {/* <div className="mt-[10px] w-full flex justify-end items-center">
            <Pagination
              firstOrder={() => handlePageChange(1)}
              endOrder={() => handlePageChange(maxPage)}
              clickForward={() => handlePageChange(page + 1)}
              clickBackward={() => handlePageChange(page - 1)}
            />
          </div> */}
        </div>
      </div>
    </>
  );
}

export default NewAnsQandAUserAll;
